module.exports = __webpack_public_path__ + "static/media/send-message.f4d246f4.png";